import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Mail, Phone, MapPin, Clock, MessageSquare } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background pt-20 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
          <p className="text-lg text-muted-foreground">
            We'd love to hear from you. Get in touch with our team.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Mail className="h-5 w-5 text-indigo-500" />
                  Email Us
                </CardTitle>
              </CardHeader>
              <CardContent>
                <a 
                  href="mailto:team@eventism.com" 
                  className="text-lg font-medium text-indigo-500 hover:text-indigo-600 transition-colors"
                >
                  team@eventism.com
                </a>
                <p className="text-sm text-muted-foreground mt-2">
                  We typically respond within 24 hours
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Phone className="h-5 w-5 text-indigo-500" />
                  Call Us
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div>
                  <a 
                    href="tel:7209074044" 
                    className="text-lg font-medium text-indigo-500 hover:text-indigo-600 transition-colors"
                  >
                    (720) 907-4044
                  </a>
                  <p className="text-sm text-muted-foreground">Main Line</p>
                </div>
                <div>
                  <a 
                    href="tel:7208081114" 
                    className="text-lg font-medium text-indigo-500 hover:text-indigo-600 transition-colors"
                  >
                    (720) 808-1114
                  </a>
                  <p className="text-sm text-muted-foreground">Alternate Line</p>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Clock className="h-5 w-5 text-indigo-500" />
                  Business Hours
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Monday - Friday</span>
                    <span className="font-medium">9:00 AM - 6:00 PM MST</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Saturday</span>
                    <span className="font-medium">10:00 AM - 4:00 PM MST</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Sunday</span>
                    <span className="font-medium">Closed</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MapPin className="h-5 w-5 text-indigo-500" />
                  Location
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-medium">Denver, Colorado</p>
                <p className="text-sm text-muted-foreground mt-1">
                  Serving the greater Denver metro area and beyond
                </p>
              </CardContent>
            </Card>
          </div>

          {/* Quick Actions */}
          <div className="space-y-6">
            <Card className="bg-gradient-to-br from-indigo-500 to-purple-600 text-foreground border-0">
              <CardContent className="pt-6">
                <MessageSquare className="h-12 w-12 mb-4 opacity-80" />
                <h3 className="text-xl font-bold mb-2">Ready to Plan Your Event?</h3>
                <p className="text-foreground/80 mb-6">
                  Get an instant quote for your event in minutes. Our platform makes it easy to browse services, customize options, and book everything you need.
                </p>
                <Button 
                  className="w-full bg-white text-indigo-600 hover:bg-white/90"
                  onClick={() => window.location.href = '/plan-event'}
                >
                  Start Planning
                </Button>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-bold mb-2">Need a Custom Quote?</h3>
                <p className="text-muted-foreground mb-4">
                  Have something specific in mind? Let us create a custom proposal tailored to your unique event needs.
                </p>
                <Button 
                  variant="outline" 
                  className="w-full"
                  onClick={() => window.location.href = '/hire-us'}
                >
                  Request Custom Quote
                </Button>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-bold mb-2">Want to Work With Us?</h3>
                <p className="text-muted-foreground mb-4">
                  We're always looking for talented vendors and staff to join our network.
                </p>
                <Button 
                  variant="outline" 
                  className="w-full"
                  onClick={() => window.location.href = '/register'}
                >
                  Join as a Vendor
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
